import type { AppContentKey } from '../entities/app-content.entity';
import type { AppContentRepository } from '../repositories/app-content-repository.interface';

export class InvalidateAppContentCacheUseCase {
  constructor(private readonly repository: AppContentRepository) {}

  execute(key: AppContentKey): Promise<void> {
    return this.repository.invalidateCache(key);
  }
}
